import { brandCodeMap } from '@/constants';
import { comm, base } from '../base';
// export const input = {
//   input: {
//     navBgc: base.color.c0023,
//     color: base.color.c0014,
//     inputLabelBg: base.color.c0023,
//     inputBg: comm.color.cffff,
//   },
//   formInput: {
//     color: comm.color.cffff,
//     singInputBg: base.color.c0024,
//     singInputColor: base.color.c0015,
//     inputBg: base.color.c0026,
//   },
// };
const cascaderTheme = {};

for (const item of Object.keys(brandCodeMap)) {
  cascaderTheme[item] = {
    cascader: {
      bgColor: comm.color.cffff,
      borderColor: base[item]?.cascaderColor.c0007,
      textColor: base[item]?.cascaderColor.c0001,
      inputBg: base[item]?.cascaderColor.c0006,
      svgColor: base[item]?.cascaderColor.c0007,
      dataDisBg: comm.color.c0001,
      dataDisColor: comm.color.c0002,
      inputFontSize: comm.fontSize.s04,
    },
  };
}

export const cascader = cascaderTheme;
